
import {initBrandCarousel} from './Carousel';
import {toggleSlide} from './Util';

class Menu {

	static defaults = {
		'scope': '.menu_item',
		'button': '.menu_item_button',
		'target': '& > .submenu',
		'preventDefault': true,
		'highlander': false
	};

	constructor( menuElement, settings ) {
		this.menuElement = menuElement;
		this.data = Object.assign( {}, Menu.defaults, settings );

		this.addMenuListener();
	}

	addMenuListener() {
		const data = this.data;

		// Skip when invalid settings.
		if ( ! data.scope || ! data.button ) {
			return;
		}

		// Add Event Listener.
		this.menuElement.addEventListener( 'click', ( ev ) => {
			const buttonEl = ev.target.closest( data.button );
			if ( buttonEl ) {
				if ( data.preventDefault ) {
					ev.preventDefault();
				}

				this.toggle( buttonEl );
			}
		} );

		if ( 'function' === typeof data.initAction ) {
			const buttonEls = this.menuElement.querySelectorAll( data.button );
			buttonEls.forEach( ( buttonEl ) => data.initAction( buttonEl ) );
		}
	}

	toggle( buttonEl ) {

		const data = this.data;

		const parentEl = buttonEl.closest( data.scope );
		const targetEl = parentEl.querySelector( data.target );

		const isActive = buttonEl.classList.contains( 'active' );

		if ( isActive ) {

			// Remove active states.
			parentEl.classList.remove( 'active_scope' );
			parentEl.ariaExpanded = false;
			buttonEl.classList.remove( 'active' );
			targetEl.classList.remove( 'active' );

			// Slide Closed.
			toggleSlide( targetEl, false );
		} else {

			// Close all other open siblings.
			// There can only be one.
			if ( data.highlander ) {

				// Get all Siblings
				const siblingParentEls = Array.from( parentEl.parentElement.children ).filter( itemEl => itemEl.matches( data.scope ) && itemEl !== parentEl );
				const siblingTargetEls = siblingParentEls.reduce( ( targetEls, itemEl ) => [ ...targetEls, ...Array.from( itemEl.querySelectorAll( data.target ) ) ], [] );
				const siblingButtonEls = siblingParentEls.reduce( ( buttonEls, itemEl ) => [ ...buttonEls, ...Array.from( itemEl.children ).filter( childEl => childEl.matches( data.button ) ) ], [] );

				// Remove active states.
				siblingParentEls.forEach( siblingParentEl => {
					siblingParentEl.classList.remove( 'active_scope' );
					siblingParentEl.ariaExpanded = false;
				} );
				siblingTargetEls.forEach( siblingTargetEl => siblingTargetEl.classList.remove( 'active' ) );
				siblingButtonEls.forEach( siblingButtonEl => siblingButtonEl.classList.remove( 'active' ) );

				// Slide them closed.
				toggleSlide( siblingTargetEls, false );
			}

			// Add Active States.
			parentEl.classList.add( 'active_scope' );
			parentEl.ariaExpanded = true;
			buttonEl.classList.add( 'active' );
			targetEl.classList.add( 'active' );

			// Slide Open.
			toggleSlide( targetEl, true );
		}
	}
}


const initMenu = function() {
	initMainMenu();
	initAccountMenu();
};


const initFacetDesktop = function() {
	initFacetMenu();
};

const initAccountMenu = function() {

	const menuEls = document.querySelectorAll( '.mdl_menu_account' );
	const settings = {
		'button': '.menu_item_button',
		'scope': '.menu_item',
		'target': '& > .submenu',
		'preventDefault': true,
	};

	if ( menuEls ) {
		menuEls.forEach( menuEl => {
			menuEl.EnMenu ??= new Menu( menuEl, settings );
		} );
	}
};

const initFacetMenu = function() {
	const facetMenuEl = document.querySelectorAll( '.facet_menu' );
	if ( ! facetMenuEl.length ) {
		return false;
	}

	const facetMenuEls = document.querySelectorAll( '.facet_menu.facet_menu--level_0' );
	const settings = {
		button: '.facet_menu__item_button',
		scope: '.facet_menu__item',
		target: '& > .facet_menu--sub',
		preventDefault: true,
		highlander: true,
	};

	if ( facetMenuEls ) {
		facetMenuEls.forEach( menuEl => {
			menuEl.EnMenu ??= new Menu( menuEl, settings );
		} );
	}
};


const initMainMenu = function() {

	document.addEventListener( 'load_submenu.koe', ( ev ) => {
		const postID = ev.target.getAttribute( 'data-nav' );
		const subMenuEl = ev.target.closest( '.mdl_mainmenu' ).querySelector( '.mdl_mainmenu__sub-ul[data-nav="' + postID + '"]' );
		if ( subMenuEl ) {
			const brandSliderEl = subMenuEl.querySelector( '.mdl_mainmenu__sub-brandslider-item' );
			if ( brandSliderEl ) {
				initBrandCarousel( brandSliderEl );
			}
		}
	} );
};



export {
	Menu as default,
	initMenu,
	initFacetDesktop,
	initAccountMenu,
	initFacetMenu,
	initMainMenu,
};
